// useAhora.ts — el instante actual (ms), refrescado cada tanto, para las cuentas regresivas del panel.
// Usa `ahoraChile()` y no `Date.now()`/`dayjs()` sueltos: es la regla del proyecto para todo lo que mira el reloj.
import { useEffect, useState } from "react";
import { ahoraChile } from "../../../utils/fechaChile";

export function useAhora(intervaloMs = 20_000): number {
  const [ahora, setAhora] = useState<number>(() => ahoraChile().valueOf());
  useEffect(() => {
    const id = setInterval(() => setAhora(ahoraChile().valueOf()), intervaloMs);
    return () => clearInterval(id);
  }, [intervaloMs]);
  return ahora;
}
